module.exports = __webpack_public_path__ + "static/media/arrow-down-orange.9861c691.svg";